import { createContext, useContext } from 'react';

import type { CarouselCollection } from 'bundles/collections-carousel/types/CarouselCollection';

export type EnterpriseCollectionsContextType = {
  isEnterpriseCollectionsLoading: boolean;
  enterpriseCollections?: CarouselCollection[];
};

const EnterpriseCollectionsContext = createContext<EnterpriseCollectionsContextType | undefined>(undefined);

export const useEnterpriseCollections = () => {
  const context = useContext(EnterpriseCollectionsContext);

  return {
    isEnterpriseCollectionsLoading: context?.isEnterpriseCollectionsLoading,
    enterpriseCollections: context?.enterpriseCollections,
  };
};

export default EnterpriseCollectionsContext;
